<div style="height: 98dvh; display: flex; justify-content: space-between; flex-direction: column">
  <div>
    <app-additional-action-header [title]="locale.currentTranslation.imprint"/>
    <div class="base-content-container">
      <div>
        <p class="text-body2 text-bold">{{ locale.currentTranslation.imprintDeclaration }}</p>
        <p class="text-body2 no-margin">{{ locale.currentTranslation.imprintLegallyResponsibleKlmr }}</p>
        <p class="text-body2 no-margin">{{ locale.currentTranslation.imprintStreet }}</p>
        <p class="text-body2 no-margin">{{ locale.currentTranslation.imprintGermany }}</p>
        <p class="text-body2 text-bold margin-top">{{ locale.currentTranslation.imprintContact }}</p>
        <a class="text-body2 no-margin" href="mailto:kontakt@klrm.berlin">{{ locale.currentTranslation.imprintEmail }}</a>
        <p class="text-body2 text-bold margin-top">{{ locale.currentTranslation.imprintRepresent }}</p>
        <p class="text-body2 no-margin">Achim Lenz</p>
        <p class="text-body2 text-bold margin-top">{{ locale.currentTranslation.imprintCommercialRegister }}</p>
        <p class="text-body2 no-margin">{{ locale.currentTranslation.imprintDistrictCourt }}</p>
        <p class="text-body2 no-margin">HRB 194222 B</p>
        <p class="text-body2 text-bold margin-top">{{ locale.currentTranslation.imprintWebsite }}</p>
        <p class="text-body2 no-margin">{{ locale.currentTranslation.imprintWebsiteText }} <span class="text-bold">{{ locale.currentTranslation.imprintWebsiteNeurisk }}.</span></p>
        <p class="text-body2 no-margin">{{ locale.currentTranslation.imprintLegallyResponsible }} <span class="text-bold">{{ locale.currentTranslation.imprintLegallyResponsibleKlmr }}.</span></p>
      </div>
    </div>
  </div>
  <div style="padding: 0 22px 14px 22px">
    <app-footer/>
  </div>
</div>
